import { render, staticRenderFns } from "./unitCollection.vue?vue&type=template&id=83b7473a&"
import script from "./unitCollection.vue?vue&type=script&lang=js&"
export * from "./unitCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports